import api from './api';

const flightManagementService = {
  // Get all flights for airliner
  getFlights: async (params = {}) => {
    const response = await api.get('/flight-management', { params });
    return response;
  },

  // Get single flight details
  getFlightById: async (id) => {
    const response = await api.get(`/flight-management/${id}`);
    return response;
  },

  // Alias for getFlightById
  getFlightDetails: async (id) => {
    const response = await api.get(`/flight-management/${id}`);
    return response;
  },

  // Create new flight
  createFlight: async (data) => {
    const response = await api.post('/flight-management', data);
    return response;
  },

  // Update flight
  updateFlight: async (id, data) => {
    const response = await api.put(`/flight-management/${id}`, data);
    return response;
  },

  // Delete flight (soft delete)
  deleteFlight: async (id) => {
    const response = await api.delete(`/flight-management/${id}`);
    return response;
  },

  // Restore deleted flight
  restoreFlight: async (id) => {
    const response = await api.post(`/flight-management/${id}/restore`);
    return response;
  },

  // Permanently delete flight (force delete)
  permanentDeleteFlight: async (id) => {
    const response = await api.delete(`/flight-management/${id}/permanent`);
    return response;
  },

  // Export flights
  exportFlights: async (format = 'excel') => {
    const response = await api.get(`/flight-management/export/${format}`, {
      responseType: 'blob'
    });
    return response;
  },

  // Cancel flight
  cancelFlight: async (id) => {
    const response = await api.post(`/flight-management/${id}/cancel`);
    return response;
  },

  // Get flight bookings
  getFlightBookings: async (id) => {
    const response = await api.get(`/flight-management/${id}/bookings`);
    return response;
  },

  // Publish flight (change status from draft to published)
  publishFlight: async (id) => {
    const response = await api.post(`/flight-management/${id}/publish`);
    return response;
  },

  // Save flight as draft
  saveDraft: async (data) => {
    const response = await api.post('/flight-management/draft', data);
    return response;
  }
};

export default flightManagementService;
